export const SHOW_FORUM_FORM = 'forumForm/SHOW';
export const showForumForm = () => ({ type: SHOW_FORUM_FORM });
